/**
 * Manages QHA's user facing notifications.
 */
class QHANotificationFactory {
  constructor(notification) {
    this.notification = notification
  }

  /**
   * Creates a new notification.
   *
   * @param {string} type type.warning | type.info | type.success
   * @param {string} message
   * @returns
   */
  createNotification(type, message, keepOpen) {
    this.notification.clear()

    if (!type || !message) {
      console.error('You must provide options to show a notification')
      return
    }

    this.notification.show(`<div><strong>${type}:</strong> ${message}</div>`, {
      theme: `notification-${type.toLowerCase()}`,
      icon: iconDictionary[type],
      duration: keepOpen ? 60000 : 5000,
      action: keepOpen
        ? {
          text: 'Okay',
          class: 'notification-action-text',
          onClick: (e, toastObject) => toastObject.goAway(0)
        }
        : null
    })
  }
}

let factory
const iconDictionary = {
  Warning: 'warning',
  Info: 'info-circle',
  Success: 'check-circle'
}

module.exports.init = notification => {
  factory = new QHANotificationFactory(notification)
}

module.exports.displayWarning = (message, keepOpen = false) =>
  factory.createNotification(this.type.WARNING, message, keepOpen)

module.exports.displayInfo = (message, keepOpen = false) =>
  factory.createNotification(this.type.INFO, message, keepOpen)

module.exports.displaySuccess = (message, keepOpen = false) => {
  factory.createNotification(this.type.SUCCESS, message, keepOpen)
  return this
}

/**
 * Enum for setting the notification style.
 */
module.exports.type = {
  WARNING: 'Warning',
  INFO: 'Info',
  SUCCESS: 'Success'
}

/**
 * Used by Vue to configure the plugin.
 */
module.exports.settings = {
  iconPack: 'fontawesome',
  position: 'bottom-center',
  duration: 5000
}
